/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum VehicleDetailImagesType {
  frontLightsPhoto = "frontLightsPhoto",
  exhaustPhoto = "exhaustPhoto",
  frontWheelPhoto = "frontWheelPhoto",
  dashboardPhoto = "dashboardPhoto",
  trunkOrSeatOpenPhoto = "trunkOrSeatOpenPhoto",
  rearSuspensionPhoto = "rearSuspensionPhoto",
  rearLightPhoto = "rearLightPhoto",
  rearWheelPhoto = "rearWheelPhoto",
  offRoadPhoto = "offRoadPhoto",
  urbanEnvironmentPhoto = "urbanEnvironmentPhoto",
  withDriverPhoto = "withDriverPhoto",
  realEnvironmentParkedPhoto = "realEnvironmentParkedPhoto",
  motionDetailPhoto = "motionDetailPhoto",
}
